import { device } from 'constants/device';

import styled from 'styled-components';
import { Headings } from '@studenten/ui-components';

export const Main = styled.main`
  background-color: ${({ theme }) => theme.system.light};
  min-height: ${({ theme }) =>
    `calc(100vh - ${theme.dimensions.footerHeight} - ${theme.dimensions.headerHeight})`};
  position: relative;
  margin-top: ${({ theme }) => theme.dimensions.headerHeight};
  @media ${device.laptop} {
    margin-top: ${({ theme }) => theme.dimensions.mobileHeaderHeight};
    min-height: ${({ theme }) =>
      `calc(100vh - ${theme.dimensions.mobileFooterHeight} - ${theme.dimensions.mobileHeaderHeight})`};
  }
`;

export const Body = styled.section`
  max-width: 820px;
  margin: auto;
  padding-top: 6rem;
  padding-bottom: 11rem;
  a {
    color: ${({ theme }) => theme.brand.blue};
    font-size: 1.8rem;
    line-height: 1.6;
    font-weight: 500;
    @media ${device.laptop} {
      font-size: 1.4rem;
    }
  }
  @media ${device.laptop} {
    width: 100%;
    padding-left: 1.6rem;
    padding-right: 1.6rem;
    padding-top: 3.2rem;
    padding-bottom: 6.4rem;
  }
`;
export const BrandBlueSpan = styled.span`
  color: ${({ theme }) => theme.brand.blue};
`;
export const PageHeading = styled(Headings.H1)`
  color: ${({ theme }) => theme.brand.blue};
  text-align: center;
  margin: auto;
  margin-bottom: 13rem;
  @media ${device.laptop} {
    margin-bottom: 4.8rem;
    font-size: 2.4rem;
    line-height: 1.2;
    margin: 0;
    text-align: left;
  }
`;
export const PageSubheading = styled(Headings.H2)`
  color: ${({ theme }) => theme.brand.blue};
  margin-bottom: 1.6rem;
  @media ${device.laptop} {
    font-size: 2.4rem;
    line-height: 1.2;
  }
`;

export const PageCategoryHeading = styled(Headings.H3)`
  color: ${({ theme }) => theme.brand.blue};
  margin-bottom: 1.6rem;
  @media ${device.laptop} {
    font-size: 2rem;
    line-height: 1.4;
  }
`


export const TextParagraph = styled.span`
  width: 100%;
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
  font-weight: 500;
  font-size: 1.8rem;
  display: block;
  line-height: 1.6;
  color: ${({ theme }) => theme.system.black};
  @media ${device.laptop} {
    font-size: 1.4rem;
  }
`;
export const TextSection = styled.section`
  width: 100%;
  margin-top: 3.2rem;
  margin-bottom: 3.2rem;
  @media ${device.laptop} {
    margin-top: 2.4rem;
    margin-bottom: 2.4rem;
  }
`;
export const TextList = styled.ul``;
export const TextListItem = styled.li`
  position: relative;

  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
  &::before {
    position: absolute;
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.system.black};
    width: 0.7rem;
    height: 0.7rem;
    border-radius: 50%;
    top: 1rem;

    margin: auto;
    left: 0px;
    @media ${device.laptop} {
      top: 0.9rem;
      width: 0.5rem;
      height: 0.5rem;
    }
  }
`;
